module.exports = {
  ar: require('./ar'),
  by: require('./by'),
  colemak: require('./colemak'),
  cs: require('./cs'),
  de: require('./de'),
  dvorak: require('./dvorak'),
  es: require('./es'),
  fa: require('./fa'),
  gr: require('./gr'),
  he: require('./he'),
  kk: require('./kk'),
  kr: require('./kr'),
  ru: require('./ru'),
  uk: require('./uk')
}
